import * as React from 'react'

import classnames from 'classnames'
import NordicLink from '../Button/NordicLink.tsx'
import { Variants } from '../Button/Variants.tsx'
import { FAQ, type FAQProps } from './FAQ.tsx'
import styles from './FAQList.module.scss'

export type FAQListProps = {
	title: string
	FAQs: FAQProps[]
}

export const FAQList: React.FC<FAQListProps> = ({ title, FAQs }) => (
	<section className={classnames(styles.questionsWrapper)}>
		<div className={styles.questions}>
			<header className={styles.header}>
				<h2 className={styles.heading}>Still have questions?</h2>
				<p>{title}</p>
			</header>
			<div>
				{FAQs.map((faq) => (
					<FAQ key={faq.title} title={faq.title}>
						{faq.children}
					</FAQ>
				))}
			</div>
			<footer className={styles.footer}>
				<p>Still have questions?</p>
				<NordicLink
					variant={Variants.secondaryDefault}
					href="/technical-expert/"
				>
					Talk to a technical expert
				</NordicLink>
			</footer>
		</div>
	</section>
)
